import {ModelType} from '~/enums/modelType'

export const SalesforceModelTypes: ReadonlyArray<ModelType> = [ModelType.SObject, ModelType.SObjectReferenceField, ModelType.SObjectChildRelationship] as const
export type TSalesforceModelType = ModelType.SObject | ModelType.SObjectReferenceField | ModelType.SObjectChildRelationship
